module.exports = __webpack_public_path__ + "img/jp.f8dc0f04.svg";